module.exports = __webpack_public_path__ + "img/678.9e150d8c.jpg";